module.exports = __webpack_public_path__ + "static/media/ws.f4fea930.svg";